import React from 'react';
import IntakeStartScreen from 'components/common/intakeStartScreen';
import ExistingPatientApp from 'components/existingPatient';

function ReasonForVisitExistingUser() {
  return (
    <IntakeStartScreen
      currentStep="hpi"
      metaTitle="Update on your condition"
    >
      <ExistingPatientApp />
    </IntakeStartScreen>
  );
}

export default ReasonForVisitExistingUser;
